import {Component, OnInit} from '@angular/core';
import {PortalService} from "../../services/portal.service";

/**
 * Showing the co2online footer for partner portalIds
 */
@Component({
    selector: 'app-footer-partner',
    templateUrl: './footer-partner.component.html',
    standalone: false
})
export class FooterPartnerComponent implements OnInit {

  /**
   * toggle if this is an internal portal or not
   */
  internalPortal: boolean;

  /**
   * custom HTML for this portal
   */
  footerHtml: string;

  /**
   * constructor
   * @param portalService
   */
  constructor(private portalService: PortalService) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.internalPortal = this.portalService.isInternalPortal();

    // do we want to show footer HTML data
    this.footerHtml = this.portalService.getConfig('embed.footer.html') ?? null;
  }

}
